import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cleanFindingView, DBDef_FindingView } from '@app/advisor-ui-shared';
import { createWorkHubManager } from '@app/styles';
import { ModuleFE_FindingView } from '../../../_entity/finding-view/ModuleFE_FindingView.js';
import { Renderer_FindingViewHeader } from './renderers/Renderer_FindingViewHeader/Renderer_FindingViewHeader.js';
import { Editor_FindingView } from '../../Editor_FindingView/Editor_FindingView.js';
import './Manager_FindingView.scss';
import { LL_V_L } from "@nu-art/thunderstorm-frontend/index";
const Editor_FindingView_Wrapper = (props) => _jsxs(LL_V_L, { className: 'manager-finding-view', children: [_jsx(Renderer_FindingViewHeader, { workHubItem: props.workHubItem, renderArgs: props.renderArgs }), _jsx(Editor_FindingView, { editable: props.editable, editMode: props.renderArgs.editMode, hideHeader: true })] });
export const Manager_FindingView = createWorkHubManager({
    module: ModuleFE_FindingView,
    dbDef: DBDef_FindingView,
    defaultItem: cleanFindingView,
    labelResolver: (item) => item.label ?? "New Finding View",
    EditorComponent: Editor_FindingView_Wrapper,
});
//# sourceMappingURL=Manager_FindingView.js.map